import { useState } from 'react';
import { glossaryService } from 'services/api';
import AvisoModal from 'components/AvisoModal';
import styles from './TermFormModal.module.css';

// Editor de un término (crear / editar). Solo super_admin llega aquí.
export default function TermFormModal({ initial, onClose, onDone }) {
  const editing = !!initial?.id;
  const [term, setTerm] = useState(initial?.term || '');
  const [definition, setDefinition] = useState(initial?.definition || '');
  const [sortOrder, setSortOrder] = useState(initial?.sort_order ?? 0);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const guardar = async () => {
    setBusy(true); setError('');
    try {
      const payload = { term: term.trim(), definition: definition.trim(), sort_order: Number(sortOrder) || 0 };
      if (editing) await glossaryService.update(initial.id, payload);
      else await glossaryService.create(payload);
      onDone(); onClose();
    } catch (e) {
      setError(e.response?.data?.message || 'No se pudo guardar.');
    } finally { setBusy(false); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${styles.modalTermino}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3><i className={`fas fa-book ${styles.iconoTitulo}`} />
            {editing ? 'Editar término' : 'Nuevo término'}</h3>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {error && <AvisoModal onClick={() => setError('')}>{error}</AvisoModal>}

          <div className="form-group">
            <label className="form-label">Término *</label>
            <input className="form-control" value={term} maxLength={160}
              onChange={e => setTerm(e.target.value)} placeholder="Ej: Quórum" />
          </div>

          <div className="form-group">
            <label className="form-label">Definición *</label>
            <textarea className="form-control" rows="6" value={definition}
              onChange={e => setDefinition(e.target.value)}
              placeholder="Explicación breve y clara para el propietario." />
          </div>

          <div className="form-group">
            <label className="form-label">Orden</label>
            <input className={`form-control ${styles.campoOrden}`} type="number" value={sortOrder}
              onChange={e => setSortOrder(e.target.value)} />
            <div className={styles.nota}>
              Menor primero. A igualdad, se ordenan alfabéticamente.
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="btn btn-primary" disabled={busy || !term.trim() || !definition.trim()}
            onClick={guardar}>
            <i className="fas fa-save" /> Guardar
          </button>
        </div>
      </div>
    </div>
  );
}
